import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReturn = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M16.75 9C17.1875 9 17.5 8.6875 17.5 8.25V3.75C17.5 3.34375 17.1875 3 16.75 3C16.3438 3 16 3.34375 16 3.75V6.28125L15.375 5.53125C14.0938 4 12.1875 3 10 3C6.15625 3 3 6.15625 3 10C3 13.875 6.15625 17 10 17C11.5937 17 13.0312 16.5 14.2187 15.625C14.5312 15.375 14.625 14.9062 14.375 14.5625C14.125 14.2188 13.6562 14.1562 13.3125 14.4062C12.4062 15.0937 11.25 15.5 10 15.5C6.96875 15.5 4.5 13.0625 4.5 10C4.5 6.96875 6.96875 4.5 10 4.5C11.7188 4.5 13.2188 5.28125 14.25 6.5L15.0938 7.5H12.25C11.8438 7.5 11.5 7.84375 11.5 8.25C11.5 8.6875 11.8438 9 12.25 9H16.75Z"
	})
});
const ForwardRef = forwardRef(SvgReturn);
export default ForwardRef;
